import {getTodayHabits} from "./get-today-habits";
import {isHabitCompleted} from "./is-habit-completed";

export const getDailyPercentage = function (date, habits, checklists){
    let todayHabits = getTodayHabits(date, habits);
    let completedCount = todayHabits.filter(habit => isHabitCompleted(habit.id, date, checklists)).length;
    let percentage = (completedCount / todayHabits.length).toFixed(2);

    return isNaN(percentage) ? 0 : percentage;
  }
